export default __webpack_public_path__ + "static/media/clio-medium2.9f1093f4.jpg";